__turbopack_context__.v({
  "actions": "LibrariesOnboarding-module-scss-module__NYNuDG__actions",
  "badge": "LibrariesOnboarding-module-scss-module__NYNuDG__badge",
  "badgeIcon": "LibrariesOnboarding-module-scss-module__NYNuDG__badgeIcon",
  "center": "LibrariesOnboarding-module-scss-module__NYNuDG__center",
  "container": "LibrariesOnboarding-module-scss-module__NYNuDG__container",
  "docsLink": "LibrariesOnboarding-module-scss-module__NYNuDG__docsLink",
  "flag": "LibrariesOnboarding-module-scss-module__NYNuDG__flag",
  "flagDesc": "LibrariesOnboarding-module-scss-module__NYNuDG__flagDesc",
  "flagList": "LibrariesOnboarding-module-scss-module__NYNuDG__flagList",
  "flagName": "LibrariesOnboarding-module-scss-module__NYNuDG__flagName",
  "flags": "LibrariesOnboarding-module-scss-module__NYNuDG__flags",
  "flagsTitle": "LibrariesOnboarding-module-scss-module__NYNuDG__flagsTitle",
  "guide": "LibrariesOnboarding-module-scss-module__NYNuDG__guide",
  "guideCode": "LibrariesOnboarding-module-scss-module__NYNuDG__guideCode",
  "guideNote": "LibrariesOnboarding-module-scss-module__NYNuDG__guideNote",
  "header": "LibrariesOnboarding-module-scss-module__NYNuDG__header",
  "runtimeTabs": "LibrariesOnboarding-module-scss-module__NYNuDG__runtimeTabs",
  "subtitle": "LibrariesOnboarding-module-scss-module__NYNuDG__subtitle",
  "target": "LibrariesOnboarding-module-scss-module__NYNuDG__target",
  "tips": "LibrariesOnboarding-module-scss-module__NYNuDG__tips",
  "title": "LibrariesOnboarding-module-scss-module__NYNuDG__title",
});
